module.exports = __webpack_public_path__ + "static/media/18.112.22c07d7a.webp";